import useDocumentMeta from "@/hooks/useDocumentMeta";
import { tvShows } from "@/data/videos";
import { tvGenres } from "@/mocks/filters";
import CategoryBrowser from "@/pages/category/components/CategoryBrowser";

export default function TvCategory() {
  useDocumentMeta({
    title: "电视剧频道 - 51无敌电影网",
    description:
      "51无敌电影网电视剧频道，热播剧集每日更新，覆盖古装、都市、悬疑、仙侠等类型，支持按集数范围和地区筛选，追剧更省心。",
    keywords: "最新电视剧,在线追剧,电视剧大全,热播剧,电视剧频道,51无敌电影网",
  });

  return (
    <CategoryBrowser
      title="电视剧频道 - 精选热播剧集"
      subtitle="热播剧集每日更新，支持类型、地区、年份与集数范围筛选，古装都市悬疑任你挑。"
      categoryLabel="电视剧"
      categoryLink="/category/tv"
      items={tvShows}
      genreOptions={tvGenres}
      showEpisodeFilter
    />
  );
}